import React from 'react'

import { useTranslation } from 'react-i18next'

import EditScoreDialog from '@components/music/title-details/Controls/PublisherControls/EditScoreButton/EditScoreDialog'
import Button from '@components/shared/Button'
import { useTitle } from '@providers/TitleProvider'
import { useDialogStore } from '@stores/dialog.store'

const EditScoreButton: React.FC = () => {
  const { t } = useTranslation()
  const openDialog = useDialogStore((s) => s.openDialog)
  const { title } = useTitle()

  return (
    <>
      <Button
        variant="primary"
        onClick={() => openDialog('edit_score')}
        className="text-md py-1.5 px-3 flex flex-row items-center justify-center">
        {t('action.editScore')}
      </Button>
      <EditScoreDialog titleId={title.uuid} />
    </>
  )
}

export default EditScoreButton
